import * as Yup from "yup";
import { useFormik } from "formik";
import { registeringForm } from "../../../utils/string";
import { postComanyAndContact } from "../../../services/saveCompanyAndContactService";
import { Google_map_Key } from "../../../api/url";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { getContactTypes } from "../../../services/fetchContactTypes";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import GooglePlacesAutocomplete from "react-google-autocomplete";
import { useNavigate } from "react-router-dom";
import Autocomplete from "react-autocomplete";
import { getCompanyByString } from "../../../services/vizyBilityServices";
import { getUserProfile } from "../../../services/authService";
import Icon from "../../icon/Icon";
import { getUserMetadata, updateUserMetadata } from "../../../services/userMetadataService";
import ApprovalPendingModal from "../../auth/ApprovalPendingModal";

const Stepper = () => {
  const navigate = useNavigate();
  const [selectCountry, setSelectCountry] = useState("us");
  const [isLoading, setIsLoading] = useState(false);
  const decodedToken = (() => {
    try { return JSON.parse(localStorage.getItem("client_info") || "null"); } catch { return null; }
  })();
  const [contactTypes, setContactTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [isCompanySelect, setIsCompanySelect] = useState({
    isSelected: false,
    CompanyId: null,
  });
  const [companyPhoneDialCode, setCompanyPhoneDialCode] = useState("1");
  const [mobilePhoneDialCode, setMobilePhoneDialCode] = useState("1");
  const [officePhoneDialCode, setOfficePhoneDialCode] = useState("1");
  const [showPendingModal, setShowPendingModal] = useState(false);

  const stripDialCode = (value, dialCode) => {
    if (!value) return "";
    return String(value).slice((dialCode || "").length).trim();
  };

  const formik = useFormik({
    initialValues: {
      companyName: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      country: "",
      countryCode: "",
      officePhone: "",
      companyNumber: "",
      firstName: decodedToken?.firstName,
      lastName: decodedToken?.lastName,
      email: decodedToken?.email,
      title: "",
      mobilePhone: "",
      contactType: "",
    },
    validationSchema: Yup.object({
      companyName: Yup.string().required("Company Name is required"),
      address1: Yup.string().required("Address 1 is required"),
      city: Yup.string(),
      state: Yup.string(),
      country: Yup.string(),
      officePhone: Yup.string().required("Office Phone is required"),
      companyNumber: Yup.string(),
      firstName: Yup.string().required("First Name is required"),
      lastName: Yup.string().required("Last Name is required"),
      email: Yup.string().email("Invalid email").required("Email is required"),
      title: Yup.string(),
      mobilePhone: Yup.string(),
      contactType: Yup.string(),
    }),
    enableReinitialize: true,
    onSubmit: (values) => {
      handleNext(values);
    },
  });

  useEffect(() => {
    getContactType();
    fetchUserProfile();
  }, []);

  const fetchUserProfile = async () => {
    try {
      const profile = await getUserProfile();
      if (profile) {
        // Map API fields to formik fields
        const newValues = {
          ...formik.values,
          firstName: profile.firstName || formik.values.firstName,
          lastName: profile.lastName || formik.values.lastName,
          email: profile.email || formik.values.email,
          address1: profile.address || formik.values.address1,
          address2: profile.address2 || formik.values.address2,
          city: profile.city || formik.values.city,
          state: profile.state || formik.values.state,
          country: profile.country || formik.values.country,
          title: profile.title || formik.values.title,
          // Registration's primary phone is the user's mobile; the secondary
          // phone is their office line. Do NOT fall back to the primary when
          // the secondary is empty — that would duplicate the same number into
          // both fields.
          mobilePhone: (profile.formattedPhoneNumber || "").replace(/\+/g, "") || formik.values.mobilePhone,
          officePhone: (profile.formattedSecondaryPhoneNumber || "").replace(/\+/g, "") || formik.values.officePhone,
        };

        formik.setValues(newValues);

        if (profile.country) {
          setSelectCountry(profile.country.toLowerCase());
        }
      }
    } catch (err) {
      console.error("Error fetching user profile:", err);
    }
  };

  const handleNext = async (values) => {
    setIsLoading(true);

    // DMS calls (company/contact save) use the generic-user token stored at
    // "vizy-bility-token". Identity calls (updateUserMetadata) must use the
    // user's own identity token instead.
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    const identityHeader = {
      authorization: `Bearer ${localStorage.getItem("vizy-identity-token")}`,
    };

    const companyPhone = stripDialCode(values.companyNumber, companyPhoneDialCode);
    const mobilePhone = stripDialCode(values.mobilePhone, mobilePhoneDialCode);
    const officePhone = stripDialCode(values.officePhone, officePhoneDialCode);

    const contactTypeId =
      values.contactType === "" || values.contactType === null || values.contactType === undefined
        ? null
        : Number(values.contactType);

    let payload = {
      companyInfo: {
        companyName: values.companyName,
        phoneNumber: companyPhone,
        address1: values.address1,
        address2: values.address2,
        city: values.city,
        province: values.state,
        country: values.country,
        companyTypeIds: [6],
        ownershipTypeId: 6,
        rankingId: "5",
        industryId: "1",
        salesRep: "mike@calvingroupinc.com",
      },
      contactInfo: {
        email: decodedToken?.email,
        firstName: values.firstName,
        lastName: values.lastName,
        address1: values.address1,
        city: values.city,
        country: values.country,
        title: values.title,
        mobile: mobilePhone,
        address2: values.address2,
        officePhone: officePhone,
        contactStatusId: 1,
        contactTypeId,
      },
    };

    let resolvedCompanyId = isCompanySelect?.CompanyId ?? null;
    if (!resolvedCompanyId && values.companyName) {
      const match = suggestions.find(
        (c) =>
          (c.CompanyName ?? c.companyName ?? c.label ?? "")
            .toString()
            .trim()
            .toLowerCase() === values.companyName.toString().trim().toLowerCase()
      );
      if (match) {
        resolvedCompanyId = match.CompanyId ?? match.companyId ?? match.id ?? null;
      }
    }

    if (resolvedCompanyId) {
      const existingCompanyId = Number(resolvedCompanyId);
      payload = {
        ...payload,
        companyInfo: {
          ...payload.companyInfo,
          companyId: existingCompanyId,
        },
        contactInfo: {
          ...payload.contactInfo,
          companyId: existingCompanyId,
        },
      };
    }

    try {
      const res = await postComanyAndContact(payload, header);
      const { companyId, contactId } = res.data;

      const storedPhone = mobilePhone || officePhone;

      // Read the current additionalMetadata first so we can merge — the PUT
      // replaces the whole string, so any keys the backend injected
      // (genericUsername / genericPassword, ...) would otherwise be wiped on
      // the first Stepper submit and DMS calls would 401 from then on.
      let existingMetadata = {};
      try {
        const existingRes = await getUserMetadata(identityHeader);
        const existingMeta = existingRes?.data?.data ?? existingRes?.data;
        if (existingMeta?.additionalMetadata) {
          try { existingMetadata = JSON.parse(existingMeta.additionalMetadata); } catch {}
        }
      } catch {} // non-fatal — fall through with empty existing

      const metadata = {
        ...existingMetadata,
        companyId,
        contactId,
        // All self-service registrations require admin approval, whether the
        // company was newly created or selected from the existing list.
        userStatus: "Pending",
        companyName: values.companyName,
        firstName: values.firstName,
        lastName: values.lastName,
        phone: storedPhone,
      };

      await updateUserMetadata(
        { additionalMetadata: JSON.stringify(metadata) },
        identityHeader
      );

      localStorage.setItem("company_id", String(companyId));
      localStorage.setItem("getAzureUserData", JSON.stringify({
        CompanyId: companyId,
        ContactId: contactId,
        CompanyName: values.companyName,
        givenName: values.firstName,
        surname: values.lastName,
        Phone: storedPhone,
        identities: [{ signInType: "emailAddress", issuerAssignedId: decodedToken?.email }],
      }));

      // Every self-service registration is Pending — block until admin approves.
      setIsLoading(false);
      setShowPendingModal(true);
    } catch (err) {
      setIsLoading(false);
      toast.error(err?.data || "Registration failed. Please try again.");
    }
  };

  const getContactType = () => {
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    getContactTypes(header)
      .then((res) => {
        setContactTypes(res.data);
        formik.setFieldValue("contactType", res.data?.[0]?.ContactTypeId);
      })
      .catch((err) => {
        toast.error(err?.data);
      });
  };

  const handlePlaceSelect = (place, formik) => {
    const addressComponents = place?.address_components || [];

    const getComponent = (types) => {
      const component = addressComponents.find((comp) => comp.types.some((type) => types.includes(type)));
      return component ? component.long_name : "";
    };

    const getComponentShortCode = (types) => {
      const component = addressComponents.find((comp) => comp.types.some((type) => types.includes(type)));
      return component ? component.short_name : "";
    };
    const countryShortCode = getComponentShortCode(["country"]);
    setSelectCountry(countryShortCode.toLowerCase());
    formik.setFieldValue("address1", place?.formatted_address || formik.values.address1);
    formik.setFieldValue("address2", getComponent(["sublocality", "neighborhood"]) || "");
    formik.setFieldValue("city", getComponent(["locality", "administrative_area_level_2"]));
    formik.setFieldValue("state", getComponent(["administrative_area_level_1"]));
    formik.setFieldValue("country", getComponent(["country"]));
    formik.setFieldValue("countryCode", countryShortCode.toLowerCase());
  };

  const SetCompany = (e) => {
    const value = e.target.value;
    formik.setFieldValue("companyName", value);

    if (value.length > 2) {
      handleSearchCompanyAnd(value);
    } else {
      setSuggestions([]);
    }
  };

  const handleSearchCompanyAnd = (value) => {
    setLoading(true);
    const payload = {
      Filter: {
        All: [],
        CompanyName: [value],
        Address1: [],
        CompanyType: [],
        CompanyRanking: [],
        Province: [],
        NeedFollowup: [],
        IndCompaniesNeedFollowup: false,
      },
      PageSize: 10,
      PageNumber: 1,
      Sort: "LastActivityDate_desc",
      IncludeCount: true,
      Role: "SalesManager",
    };
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };

    getCompanyByString(payload, header)
      .then((res) => {
        setLoading(false);
        const companies = res.data.map((company) => ({
          ...company,
          label: company.CompanyName,
          id: company.CompanyId,
        }));
        setSuggestions(companies);
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.data || "Error fetching companies");
      });
  };

  const selectCompany = (value) => {
    const selectedCompany = suggestions.find((company) => company.label === value);
    if (selectedCompany) {
      const cid = selectedCompany.CompanyId ?? selectedCompany.companyId ?? selectedCompany.id;
      formik.setFieldValue("companyName", selectedCompany.CompanyName ?? selectedCompany.companyName);
      formik.setFieldValue("address1", selectedCompany.Address1 ?? selectedCompany.address1);
      formik.setFieldValue("address2", selectedCompany.Address2 ?? selectedCompany.address2);
      formik.setFieldValue("city", selectedCompany.City ?? selectedCompany.city);
      formik.setFieldValue("state", selectedCompany.State ?? selectedCompany.state);
      formik.setFieldValue("country", selectedCompany.Country ?? selectedCompany.country);
      setIsCompanySelect({
        ...isCompanySelect,
        isSelected: true,
        CompanyId: cid ?? null,
      });
    }
  };

  return (
    <>
      <div>
        <div className="bg-[#fff] pb-[100px]">
          <div className="custom-container">
            <div className="py-[29px]">
              <div className="text-[#161412] lg:text-[48px] md:text-[38px] sm:text-[28px] text-[18px] font-[Roboto] font-black	text-center mb-[30px]">
                {registeringForm.THANKS_REGISTERING}
              </div>
              <form onSubmit={formik.handleSubmit}>
                <div className="grid md:grid-cols-2 grid-cols-1 gap-4">
                  <div className="bg-[#F2F2F2] p-[21px]  rounded-lg">
                    <div>
                      <label className="block text-[Roboto] text-[#000] text-[16px] font-normal">Company Name</label>
                      <div className="relative">
                        <div className="flex items-center">
                          <Autocomplete
                            getItemValue={(item) => item.label}
                            items={loading ? [{ label: "Loading..." }] : isCompanySelect.isSelected ? [] : suggestions}
                            renderItem={(item, isHighlighted) => (
                              <div
                                key={item.label}
                                style={{
                                  padding: "10px",
                                  borderBottom: "1px solid #ddd",
                                }}
                                className="p-[10px] text-black cursor -pointer bg-white hover:bg-[#FEBA06] hover:text-white"
                              >
                                {item.label}
                              </div>
                            )}
                            onBlur={formik.handleBlur}
                            value={formik.values.companyName}
                            onChange={!isCompanySelect.isSelected ? SetCompany : undefined}
                            onSelect={!isCompanySelect.isSelected ? selectCompany : undefined}
                            inputProps={{
                              placeholder: "Enter here",
                              className: `${isCompanySelect.isSelected ? " bg-[#d0d0d0] cursor-not-allowed" : " bg-white"
                                } w-full input  border border-[#F2F2F2] text-black rounded-md py-[14px] px-[15px] mt-[10px] text-[16px] font-[Roboto] font-normal focus:outline-none`,
                            }}
                            menuStyle={{
                              position: "absolute",
                              top: "100%",
                              left: "0",
                              width: "100%",
                              backgroundColor: "white",
                              border: "1px solid #ddd",
                              borderRadius: "4px",
                              maxHeight: "200px",
                              overflowY: "auto",
                              zIndex: "1",
                            }}
                            wrapperStyle={{ width: "100%" }}
                            className="w-full"
                          />
                          {isCompanySelect?.isSelected ? (
                            <Icon
                              icon={"EditIcon"}
                              className="text-[53px] fill-black text-black cursor-pointer ml-[30px] mt-[14px]"
                              onClick={() => {
                                setIsCompanySelect({
                                  ...isCompanySelect,
                                  isSelected: false,
                                  CompanyId: null,
                                });
                              }}
                            />
                          ) : null}
                        </div>
                      </div>
                      {formik.touched.companyName && formik.errors.companyName ? (
                        <p className="text-red-400 mt-1 text-[14px]">{formik.errors.companyName}</p>
                      ) : null}
                    </div>

                    <div className="mt-[20px]">
                      <label className="block text-[Roboto] text-[#000] text-[16px] font-normal">Address 1</label>
                      <GooglePlacesAutocomplete
                        apiKey={Google_map_Key}
                        onPlaceSelected={(place) => handlePlaceSelect(place, formik)}
                        onChange={(e) => {
                          formik.setValues({
                            ...formik.values,
                            address1: e.target.value,
                          });
                        }}
                        options={{
                          types: ["address"],
                        }}
                        value={formik.values.address1}
                        disabled={isCompanySelect.isSelected}
                        className={`input ${isCompanySelect.isSelected ? " bg-[#d0d0d0] cursor-not-allowed" : " bg-white"
                          } border border-[#F2F2F2] text-black w-full rounded-md py-[14px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg`}
                      />
                      {formik.touched.address1 && formik.errors.address1 ? (
                        <p className="text-red-400 mt-1 text-[14px]">{formik.errors.address1}</p>
                      ) : null}
                    </div>

                    <div className="mt-[20px]">
                      <label className="block text-[Roboto] text-[#000] text-[16px] font-normal">Address 2</label>
                      <input
                        type="text"
                        name="address2"
                        onChange={formik.handleChange}
                        value={formik.values.address2}
                        placeholder="Enter here"
                        disabled={isCompanySelect.isSelected}
                        className={`input ${isCompanySelect.isSelected ? " bg-[#d0d0d0] cursor-not-allowed" : " bg-white"
                          } border border-[#F2F2F2] text-black w-full rounded-md py-[14px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg`}
                      />
                    </div>

                    <div className="grid gap-4 md:grid-cols-1 lg:grid-cols-2">
                      <div className="mt-[20px]">
                        <label className="block text-[Roboto] text-[#000] text-[16px] font-normal">City</label>
                        <input
                          type="text"
                          name="city"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.city}
                          placeholder="Enter here"
                          disabled={isCompanySelect.isSelected}
                          className={`input  ${isCompanySelect.isSelected ? " bg-[#d0d0d0] cursor-not-allowed" : " bg-white"
                            } border border-[#F2F2F2] text-black w-full rounded-md py-[14px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg`}
                        />
                        {formik.touched.city && formik.errors.city ? (
                          <p className="text-red-400 mt-1 text-[14px]">{formik.errors.city}</p>
                        ) : null}
                      </div>

                      <div className="mt-[20px]">
                        <label className="block text-[Roboto] text-[#000] text-[16px] font-normal">State</label>
                        <input
                          type="text"
                          name="state"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.state}
                          placeholder="Enter here"
                          disabled={isCompanySelect.isSelected}
                          className={`input  ${isCompanySelect.isSelected ? " bg-[#d0d0d0] cursor-not-allowed" : " bg-white"
                            } border border-[#F2F2F2] text-black w-full rounded-md py-[14px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg`}
                        />
                        {formik.touched.state && formik.errors.state ? (
                          <p className="text-red-400 mt-1 text-[14px]">{formik.errors.state}</p>
                        ) : null}
                      </div>
                    </div>

                    <div className="mt-[20px]">
                      <label className="block text-[Roboto] text-[#000] text-[16px] font-normal">Country</label>
                      <input
                        type="text"
                        name="country"
                        onChange={formik.handleChange}
                        value={formik.values.country}
                        placeholder="Enter here"
                        disabled={isCompanySelect.isSelected}
                        className={`input  ${isCompanySelect.isSelected ? " bg-[#d0d0d0] cursor-not-allowed" : " bg-white"
                          } border border-[#F2F2F2] text-black w-full rounded-md py-[14px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg`}
                      />
                      {formik.touched.country && formik.errors.country ? (
                        <p className="text-red-400 mt-1 text-[14px]">{formik.errors.country}</p>
                      ) : null}
                    </div>

                    <div className="mt-[20px]">
                      <label className="block text-[Roboto] text-[#000] text-[16px] font-normal">Office Phone</label>
                      <div className="relative">
                        <PhoneInput
                          country={selectCountry}
                          placeholder="Enter here"
                          name="companyNumber"
                          value={formik.values.companyNumber}
                          onChange={(value, country) => {
                            formik.setFieldValue("companyNumber", value);
                            setCompanyPhoneDialCode(country?.dialCode || "1");
                          }}
                          className={`input  ${isCompanySelect.isSelected ? " bg-[#d0d0d0] cursor-not-allowed" : " bg-white"
                            } border border-[#F2F2F2] text-black w-full rounded-md py-[8.5px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg`}
                          containerClass="w-full mt-[10px]"
                          inputStyle={{
                            width: "100%",
                            borderRadius: "8px",
                            border: "0px solid #F2F2F2",
                            fontFamily: "Roboto",
                            fontSize: "16px",
                            color: "#000",
                            background: ` ${isCompanySelect.isSelected ? "#d0d0d0" : "white"}`,
                          }}
                          buttonStyle={{
                            border: "0px solid #F2F2F2",
                            borderRadius: "8px 0 0 8px",
                            backgroundColor: "#fff",
                            background: ` ${isCompanySelect.isSelected ? "#d0d0d0" : "white"}`,
                          }}
                          disabled={isCompanySelect.isSelected}
                        />
                        {isCompanySelect.isSelected ? (
                          <div className="absolute w-full h-full top-0 cursor-not-allowed"></div>
                        ) : null}
                      </div>
                      {formik.touched.companyNumber && formik.errors.companyNumber ? (
                        <p className="text-red-400 mt-1 text-[14px]">{formik.errors.companyNumber}</p>
                      ) : null}
                    </div>
                  </div>

                  <div className="bg-[#F2F2F2] p-[21px]  rounded-lg">
                    <div className="grid gap-4 md:grid-cols-1 lg:grid-cols-2">
                      <div className="mt-[20px] md:mt-[0px]">
                        <label className="block text-[Roboto] text-[#000] text-[16px] font-normal">First Name</label>
                        <input
                          type="text"
                          name="firstName"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.firstName}
                          placeholder="Enter here"
                          className="input bg-white border border-[#F2F2F2] text-black w-full rounded-md py-[14px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg"
                        />
                        {formik.touched.firstName && formik.errors.firstName ? (
                          <p className="text-red-400 mt-1 text-[14px]">{formik.errors.firstName}</p>
                        ) : null}
                      </div>

                      <div className="mt-[20px] md:mt-[0px]">
                        <label className="block text-[Roboto] text-[#000] text-[16px] font-normal">Last Name</label>
                        <input
                          type="text"
                          name="lastName"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.lastName}
                          placeholder="Enter here"
                          className="input bg-white border border-[#F2F2F2] text-black w-full rounded-md py-[14px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg"
                        />
                        {formik.touched.lastName && formik.errors.lastName ? (
                          <p className="text-red-400 mt-1 text-[14px]">{formik.errors.lastName}</p>
                        ) : null}
                      </div>
                    </div>

                    <div className="mt-[20px]">
                      <label className="block text-[Roboto] text-[#000] text-[16px] font-normal">Email</label>
                      <input
                        type="email"
                        name="email"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.email}
                        placeholder="Enter here"
                        disabled
                        className="input bg-white border border-[#F2F2F2] text-black w-full rounded-md py-[14px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg"
                      />
                      {formik.touched.email && formik.errors.email ? (
                        <p className="text-red-400 mt-1 text-[14px]">{formik.errors.email}</p>
                      ) : null}
                    </div>

                    <div className="mt-[20px]">
                      <label className="block text-[Roboto] text-[#000] text-[16px] font-normal">Title</label>
                      <input
                        type="text"
                        name="title"
                        onChange={formik.handleChange}
                        value={formik.values.title}
                        placeholder="Enter here"
                        className="input bg-white border border-[#F2F2F2] text-black w-full rounded-md py-[14px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg"
                      />
                    </div>
                    <div className="mt-[20px]">
                      <label className="block text-[Roboto] text-[#000] text-[16px] font-normal">Mobile Phone</label>
                      <PhoneInput
                        country={selectCountry}
                        placeholder="Enter here"
                        name="mobilePhone"
                        value={formik.values.mobilePhone}
                        onChange={(value, country) => {
                          formik.setFieldValue("mobilePhone", value);
                          setMobilePhoneDialCode(country?.dialCode || "1");
                        }}
                        className="input bg-white border border-[#F2F2F2] text-black w-full rounded-md py-[8.5px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg"
                        containerClass="w-full mt-[10px]"
                        inputStyle={{
                          width: "100%",
                          borderRadius: "8px",
                          border: "0px solid #F2F2F2",
                          fontFamily: "Roboto",
                          fontSize: "16px",
                          color: "#000",
                        }}
                        buttonStyle={{
                          border: "0px solid #F2F2F2",
                          borderRadius: "8px 0 0 8px",
                          backgroundColor: "#fff",
                        }}
                      />
                    </div>
                    <div className="mt-[20px]">
                      <label className="block text-[Roboto] text-[#000] text-[16px] font-normal">Office Phone</label>
                      <PhoneInput
                        country={selectCountry}
                        placeholder="Enter here"
                        name="officePhone"
                        value={formik.values.officePhone}
                        onChange={(value, country) => {
                          formik.setFieldValue("officePhone", value);
                          setOfficePhoneDialCode(country?.dialCode || "1");
                        }}
                        className="input bg-white border border-[#F2F2F2] text-black w-full rounded-md py-[8.5px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg"
                        containerClass="w-full mt-[10px]"
                        inputStyle={{
                          width: "100%",
                          borderRadius: "8px",
                          border: "0px solid #F2F2F2",
                          fontFamily: "Roboto",
                          fontSize: "16px",
                          color: "#000",
                        }}
                        buttonStyle={{
                          border: "0px solid #F2F2F2",
                          borderRadius: "8px 0 0 8px",
                          backgroundColor: "#fff",
                        }}
                      />
                      {formik.touched.officePhone && formik.errors.officePhone ? (
                        <p className="text-red-400 mt-1 text-[14px]">{formik.errors.officePhone}</p>
                      ) : null}
                    </div>



                    <div className="mt-[20px]">
                      <label className="block text-[Roboto] text-[#000] text-[16px] font-normal">Contact Type</label>
                      <select
                        name="contactType"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.contactType}
                        className="input bg-white border border-[#F2F2F2] text-black w-full rounded-md py-[14px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg"
                      >
                        {contactTypes.map((item) => {
                          return (
                            <option key={item.ContactTypeId} value={item.ContactTypeId} className="text-[16px] font-bold font-[Roboto]">
                              <div className="!my-[10px] !mx-[30px] leading-[200px]">{item.ContactTypeName}</div>
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="mt-[30px] text-center">
                  <button
                    type="submit"
                    className="border border-[#FEBA06] bg-[#FEBA06] px-[21px] py-[15px] font-bold text-[16px] font-bold font-[Roboto] rounded-lg text-[#161412]"
                  >
                    {isLoading ? <span className="loader"></span> : registeringForm.COMPLETE_REGISTRATION}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <ApprovalPendingModal open={showPendingModal} />
    </>
  );
};

export default Stepper;
